
import React from "react";
import S1_Header from "../MainPage/S1_Header";
import Footer from "../MainPage/S2_Footer";

const MainPage = () => {
  return (
    <div>
        <S1_Header />
        <Footer />
    </div>
  );
};

export default MainPage;
